export type DocsIconCategory = {
    name        : string
    itemIcons   : string[]
}

export const DOCS_ICON_CATEGORIES: DocsIconCategory[] = [

    {
        name        : 'Popular',
        itemIcons   : [
            'file_text',
            'wiki',
            'information',
            'book',
            'brand',
            'assets',
            'file_binary',
            'file_code',
            'file_contact',
            'globe',
            'graduation',
            'graph',
            'image',
            'mail_black',
            'mail_read',
            'calendar'
        ]
    },
    {
        name        : 'Project Management',
        itemIcons   : [
            'folder',
            'project',
            'dev',
            'sprint',
            'backlog',
            'requests',
            'group',
            'section',
            'tag',
            'workspace',
            'briefcase',
            'view-projects-list',
            'view-portfolio',
        ]
    },
    {
        name        : 'Views',
        itemIcons   : [
            'view',
            'view-list',
            'view-table',
            'view-board',
            'view-calendar',
            'view-events-summary',
            'event',
            'view-expenses',
            'scrum',
            'view-gantt',
            'view-workload',
            'view-activity',
            'view-what-is-done',
            'view-pastdue',
            'view-priorities',
            'view-action-required',
            'view-tasks-by-user',
            'view-dashboard',
            'report',
            'user',
            'users'
        ]
    },
    {
        name        : 'Development & Technology',
        itemIcons   : [
            'mobile',
            'desktop',
            'globe',
            'cloud',
            'upload',
            'download',
            'server',
            'database',
            'key',
            'api',
            'qa',
            'bug',
            'idea',
            'rocket',
            'microchip',
            'embed',
            'lightning',
            'network',
            'graph',
        ]
    },
    {
        name        : 'Collaboration & Communication',
        itemIcons   : [
            'support',
            'megaphone',
            'contact',
            'leads',
            'mail_black',
            'mail_read',
            'userSearch',
            'social_broadcast',
            'target',
            'aim',
            'mention',
            'quote',
            'social_rss',
            'search',
            'resources',
            'request',
            'request2',
            'link',
            'user-card', 'offices'
        ]
    },
    {
        name        : 'Documentation',
        itemIcons   : [
            'files',
            'page',
            'file_contact',
            'file_code',
            'file_audio',
            'file_binary',
            'file_media',
            'file_video',
            'file_archive',
            'file_text',
            'spreadsheet',
            'img',
        ]
    },
    {
        name        : 'Financials & e-commerce',
        itemIcons   : [
            'money',
            'credit_card',
            'inventory',
            'shopping_cart',
            'suitcase',
        ]
    },
    {
        name        : 'Education',
        itemIcons   : [
            'bookmark',
            'book',
            'wiki',
            'education',
            'graduate',
        ]
    },
    {
        name        : 'Creativity & Design',
        itemIcons   : [
            'pencil',
            'paint',
            'paint_roller',
            'brush',
        ]
    },
    {
        name        : 'Brands',
        itemIcons   : [
            'windows',
            'android',
            'apple',
            'figma',
            'googleCalendar',
            'googleDoc',
            'googleMap',
            'googleSheet',
            'googleSlides',
            'twitterX',
            'twitter',
            'facebook',
            'youtube',
            'brand',
        ]
    },
    {
        name        : 'Entertainment & Media',
        itemIcons   : [
            'chess',
            'game_console',
            'music',
            'speaker',
            'microphone',
            'football_ball',
            'flask',
            'beer',
            'birthday_cake',
            'hotel',
            'first_aid',
            'flame',
            'tshirt',
            'wheelchair',
            'flag',
            'squirrel',
            'tools',
            'telescope',
            'home',
            'milestone',
            'geo',
            'watch',
            'law',
            'feather',
            'magic_wand',
            'projection_screen',
            'smile',
            'smile_sad',
            'zzz',
            'burst',
            'life_ring',
            'tachometer',
            'anchor',
            'trophy',
        ]
    },
]



export const DocIconOptions  = [
    [
    'file_text',
    'wiki',
    'information',

    'book',
    'brand',
    'assets',
    'file_binary',
    'file_code',
    'file_contact',
    'globe',
    'graduation',
    'graph',
    'image',
    'mail_black',
    'mail_read',
    'calendar'
    ]
];

